import { useDispatch, useSelector } from "react-redux";
import socket from "../../assets/socketConnection";
import { setMapLevel } from "../../redux/map/map.actions";
// import LoadingPage from "../../components/loadingPage/loadingPage.component";
import { submitPreReqAsync } from "../../redux/preReq/preReq.actions";
import {
  selectPreReqSubmitIsLoading,
  selectIsPreReqSubmitValid,
} from "../../redux/preReq/preReq.selectors";
import {
  selectNewRequestLoadWeight,
  selectNewRequestBargiryDate,
  selectNewRequestTakhliehDate,
  selectPackagingType,
  selectVehicleType,
  selectAlertNotifShow,
  selectNewRequestLoadDescLoad,
} from "../../redux/newRequest/newRequest.selectors";
import { SubmitReqPreSubBtnsStyled } from "./SubmitReqPreSubBtns.styles";
import { setAlertNotifShow } from "../../redux/newRequest/newRequest.actions";
import { useEffect, useState } from "react";

const SubmitReqPreSubBtns = ({ ...others }) => {
  const [valid, setValid] = useState(false);
  const dispatch = useDispatch();
  // const preReqSubmitIsLoading = useSelector(selectPreReqSubmitIsLoading);
  const isPreReqSubmitValid = useSelector(selectIsPreReqSubmitValid);
  const weight = useSelector(selectNewRequestLoadWeight);
  const loadDate = useSelector(selectNewRequestBargiryDate);
  const evDate = useSelector(selectNewRequestTakhliehDate);
  const packaging = useSelector(selectPackagingType);
  const vehicleType = useSelector(selectVehicleType);
  const loadDesc = useSelector(selectNewRequestLoadDescLoad);
  const alertShow = useSelector(selectAlertNotifShow);
  useEffect(() => {
    console.log(
      isPreReqSubmitValid &&
        Boolean(weight) &&
        Boolean(loadDesc) &&
        Boolean(loadDate) &&
        Boolean(evDate) &&
        Boolean(packaging),
      { loadDesc },
      Boolean(loadDesc)
    );
    setValid(
      isPreReqSubmitValid &&
        Boolean(weight) &&
        Boolean(loadDesc) &&
        Boolean(loadDate) &&
        Boolean(evDate) &&
        Boolean(packaging)
    );
  }, [weight, loadDate, evDate, packaging, isPreReqSubmitValid, loadDesc]);
  console.log("valid", valid);
  const onSubClick = () => {
    // alert("sub");
    // setShowLoading(true);
    if (vehicleType === "heavy" && !valid) {
      dispatch(setAlertNotifShow(true));
    }
    if (vehicleType === "heavy") {
      valid && dispatch(submitPreReqAsync(socket));
      valid && console.log("1");
    } else {
      dispatch(submitPreReqAsync(socket));
      console.log("2");
    }
  };

  const onCancelClick = () => {
    dispatch(setMapLevel(0));
  };

  return (
    <>
      {/* <LoadingPage isShow={preReqSubmitIsLoading} /> */}

      <SubmitReqPreSubBtnsStyled {...others}>
        <button onClick={onCancelClick} className="cancel">
          لغو
        </button>
        <button
          onClick={onSubClick}
          className="submit font-weight-bold"
          disabled={!isPreReqSubmitValid || !loadDesc}
        >
          {vehicleType === "heavy" ? "جزئیات بیشتر" : "ثبت درخواست"}
        </button>
      </SubmitReqPreSubBtnsStyled>
    </>
  );
};

export default SubmitReqPreSubBtns;
